/**
* @Description 文件功能说明：车辆组件
* @Author
* @Time 2021/6/4
**/
<template>
    <div class="view-tree-table">
        <!-- router-title-box start -->
      <div class="router-title-box" >
        <div class="router-title-item">
          <a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
          <div class="router-title-tit">

            <el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
              <el-tab-pane label="今日进场记录" name="first" clor="red"></el-tab-pane>
              <el-tab-pane label="历史进场记录" name="second"></el-tab-pane>
            </el-tabs>

          </div>
        </div>
      </div>

      <ApproachToday v-show="activeName == 'first'" ref="approachToday"/>
      <ApproachRecord v-show="activeName == 'second'" ref="approachRecord"/>
		  <!-- router-title-box end -->
		
    </div>
</template>

<script>
	import ApproachToday from "@/components_pages/Approach/ApproachToday";
	import ApproachRecord from "@/components_pages/Approach/ApproachRecord";

	export default {
	    /*
	     * 组件名
	     */
	    name: "ApproachT",
	    /**
	     * 引用组件
	     * */
	    components: {
	        ApproachToday,
          ApproachRecord,
	    },
	    /**
	     * 数据定义
	     * */
	    data(){
	        return {
	            // mini max tree box
            activeName: 'first'

	        }
	    },
	    /**
	     * 方法定义
	     */
	    methods:{
	        /**
	         * @Des 关闭路由
	         * @Auth
	         * @Date
	         */
	        closeRouter () {
	            // 跳转到 首页
	            this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
	        },// closeRouter

          handleClick(tab, event) {
            if (tab.index == 0) {
              // 请求1
            } else if (tab.index == 1) {
              // 请求2
            } else if (tab.index == 2) {

            }
          },// handleClick
	        
	    },// methods
	    /**
	     * 初始化加载
	     */
	    mounted() {
	    	
	    },// mounted
	    
	}// export default
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/system-manager/approach/ApproachT.vue